module.exports = __webpack_public_path__ + "static/media/kind-awards-badge.b66c712a.png";